import { PanelSectionCSS } from './PanelSectionCSS.styled'
import { useLayoutV3State } from 'hooks/useLayoutV3State'
import { useMemo } from 'react'
import { PanelSectionBase } from './PanelSectionBase/PanelSectionBase'
import { useLvgState } from 'hooks/games/lvg/useLvgState'
import { useNavigate } from 'react-router-dom'

export const PanelSection = ({ contentType, icon, title, content, defaultOpen }) => {
  const navigateTo = useNavigate()
  const { currentGame } = useLayoutV3State()
  const { resetActiveOrder } = useLvgState()
  const openOnGame = useMemo(() => currentGame === contentType, [currentGame])
  const handleGameChange = () => {
    if (contentType && content) {
      navigateTo(`/game/${contentType}`)
      resetActiveOrder()
    }
  }
  return (
    <PanelSectionCSS icon={icon}>
      <PanelSectionBase
        open={defaultOpen || openOnGame}
        onSummaryClick={handleGameChange}
        openPanelSummary={
          <h1>
            <div
              className={`icon ${icon.masked && 'masked'}`}
              style={icon.size ? { height: icon.size, width: icon.size } : {}}
            />
            {title}
          </h1>
        }
        closePanelSummary={
          <h1 className='panelClosed'>
            <div className={`icon panelClosed ${icon.masked && 'masked'}`} />
          </h1>
        }
        content={content}
      />
    </PanelSectionCSS>
  )
}
